import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'
import { now } from '../common/utils';
import { LAST_BEGIN, LAST_END, PRE_END } from './const';

Vue.use(Vuex)

const state = {
  _now: now(),
  userInfo: null, //用户信息
  stageLevel: null, // 用户等级信息
  
  saleType: 0, //  售卖类型 0 ：不可购买 1：可购买预付商品 2：可购买尾款商品 3：全额购买尾款商品 4：已完成购买
  preMap: null, // 预付商品:  {goodsName: goodsInfo}
  lastMap: null, // 尾款商品:  {goodsName: goodsInfo}
  goodsMap: null, // 商品Map:  {goodsId: goodsInfo}
  canGoodsIds: null, // 可购买下单的商品Ids
  physicalGoods: null, // 实物商品ID
  buyInfos: null, // 购买信息
  buyGoods: null,
  dkBuyInfo: null, // 斗K购买信息
  subId: 0,
  qrCode: '',
  PRE_END: PRE_END,
  LAST_BEGIN: LAST_BEGIN,
  LAST_END: LAST_END
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})
